import { gql } from 'apollo-boost'

const MARK_MENU_DEFINITION_TASK_MISC_AS_VERIFIED = gql`
  mutation markMenuDefinitionTaskMiscAsVerified($id: ID!, $comment: String) {
    markMenuDefinitionTaskMiscAsVerified(id: $id, comment: $comment) {
      id
      miscTaskVerifiedDate
      miscTaskVerifiedComment
    }
  }
`

export default MARK_MENU_DEFINITION_TASK_MISC_AS_VERIFIED
